var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"text-center"},[(_vm.overlay)?_c('div',[_c('v-overlay',{attrs:{"opacity":_vm.overlayOpacity,"color":_vm.overlayColor,"z-index":"4"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.progressColor,"width":"6","size":"74"}})],1)],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }